/* global axios */
import ApiClient from './ApiClient';

// Nested under inboxes (Api::V1::Accounts::WhatsappTemplatesController is
// routed inside `resources :inboxes`, same convention as
// Inboxes#syncTemplates/#createCSATTemplate in api/inboxes.js), not a
// flat top-level resource - a template has no identity outside its inbox.
class WhatsappTemplatesAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_templates`);
  }

  create(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates`, {
      template,
    });
  }

  delete(inboxId, name) {
    return axios.delete(
      `${this.url}/${inboxId}/whatsapp_templates/${encodeURIComponent(name)}`
    );
  }

  sync(inboxId) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates/sync`);
  }
}

export default new WhatsappTemplatesAPI();
